/** Dev mode → Test on phone. SUN-88c: the Test Phone page is the one place for testing apps; this tab is only a link to it. */
import { useInRouterContext, useNavigate } from 'react-router-dom';
import { PHONE_ROUTE } from '../../../modules/test-phone/phoneArea';

/** Go to a page of AURA: inside the router when there is one, else a plain page load. */
function useGo(): (to: string) => void {
  const inRouter = useInRouterContext();
  // eslint-disable-next-line react-hooks/rules-of-hooks -- the router context never changes while this mounts
  const nav = inRouter ? useNavigate() : null;
  return (to) => { if (nav) nav(to); else window.location.assign(to); };
}

export function TestOnPhone() {
  const go = useGo();
  return (
    <div className="kw-grid">
      <div className="kw-box" data-testid="test-phone-link">
        <h4>Test on phone</h4>
        <div className="kw-small">Testing the phone apps now happens on the Test Phone page: the phone, the changes waiting for a test, and the lessons.</div>
        <button type="button" className="kw-btn" onClick={() => go(PHONE_ROUTE)}>Open Test Phone page ↗</button>
      </div>
    </div>
  );
}
